import { render, staticRenderFns } from "./Pinned.vue?vue&type=template&id=d39831a0&"
import script from "./Pinned.vue?vue&type=script&lang=js&"
export * from "./Pinned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports